// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Belt_Array from "../../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as PartnerScoreConfig from "../../../domain/store/PartnerScoreConfig.bs.js";
import * as PartnerScoreV1CssHelper from "../../../domain/helper/PartnerScoreV1CssHelper.bs.js";

function ScoreSliderTrack(Props) {
  var threshold_values = Props.threshold_values;
  return React.createElement("div", {
              className: "slider-track",
              style: {
                background: PartnerScoreV1CssHelper.getSliderTrackBackgroundColor(threshold_values, PartnerScoreConfig.slider_colors)
              }
            }, React.createElement("div", {
                  className: "slider-markings"
                }, Belt_Array.map(PartnerScoreConfig.sliderMarkings, (function (mark) {
                        return React.createElement("div", {
                                    className: "slider-marking"
                                  }, mark);
                      }))));
}

var make = ScoreSliderTrack;

export {
  make ,
  
}
/* react Not a pure module */
